import { useEffect, useState } from "react";
import { useLocation, matchPath } from "react-router-dom";
import { api } from "../../services/api";
import { labelTipo, normalizarProjetoBackend, obterTipoProjeto } from "../../utils/projetos";

function TrilhaNavegacao({ aoIrHome, aoIrCategoria }) {
  const location = useLocation();

  const mapaRotas = {
    RA: "/ra",
    RV: "/rv",
    "Vídeo 360": "/video360",
    "Vídeo 360i": "/video360i",
  };

  const mapaCategorias = {
    "/ra": "Realidade Aumentada",
    "/rv": "Realidade Virtual",
    "/video360": "Vídeo 360",
    "/video360i": "Vídeo 360i",
  };

  const matchDetalhe = matchPath("/projeto/:id", location.pathname);
  const [projetoDetalhe, setProjetoDetalhe] = useState(null);

  useEffect(() => {
    let ativo = true;

    async function carregarProjetoDetalhe() {
      if (!matchDetalhe) {
        setProjetoDetalhe(null);
        return;
      }

      const routeId = matchDetalhe.params.id;
      setProjetoDetalhe(null);

      try {
        const ehBackend = typeof routeId === "string" && routeId.startsWith("backend-");
        const numericId = ehBackend ? Number(routeId.replace("backend-", "")) : Number(routeId);
        const response = await api.get(`/cards/${numericId}`);
        if (!ativo) return;
        setProjetoDetalhe(normalizarProjetoBackend(response.data));
      } catch (error) {
        if (!ativo) return;
        setProjetoDetalhe(null);
      }
    }

    carregarProjetoDetalhe();

    return () => {
      ativo = false;
    };
  }, [location.pathname]);

  if (matchDetalhe && projetoDetalhe) {
    const tipo = obterTipoProjeto(projetoDetalhe);
    const nomeTipo = labelTipo(tipo);
    const rota = mapaRotas[nomeTipo] || mapaRotas[tipo];

    return (
      <nav className="TrilhaNavegacao">
        <span className="TrilhaNavegacao-link" onClick={aoIrHome}>Home</span>
        {nomeTipo && <span className="TrilhaNavegacao-separador">|</span>}
        {nomeTipo && (
          <span
            className="TrilhaNavegacao-link"
            onClick={function () {
              if (rota) aoIrCategoria(rota);
            }}
          >
            {nomeTipo}
          </span>
        )}
        <span className="TrilhaNavegacao-separador">|</span>
        <span className="TrilhaNavegacao-atual">{projetoDetalhe.titulo}</span>
      </nav>
    );
  }

  const categoriaAtual = Object.keys(mapaCategorias).find((rota) =>
    location.pathname.startsWith(rota)
  );

  if (categoriaAtual) {
    return (
      <nav className="TrilhaNavegacao">
        <span className="TrilhaNavegacao-link" onClick={aoIrHome}>Home</span>
        <span className="TrilhaNavegacao-separador">|</span>
        <span className="TrilhaNavegacao-atual">{mapaCategorias[categoriaAtual]}</span>
      </nav>
    );
  }

  if (location.search.includes("?q=")) {
    return (
      <nav className="TrilhaNavegacao">
        <span className="TrilhaNavegacao-link" onClick={aoIrHome}>Home</span>
        <span className="TrilhaNavegacao-separador">|</span>
        <span className="TrilhaNavegacao-atual">Resultados</span>
      </nav>
    );
  }

  return null;
}

export default TrilhaNavegacao;